export default "__VITE_ASSET__373d6f12__"